// A root user opened through Admin's scoped editor keeps root authority while
// being restricted to one target. Direct venue/advertiser accounts never pass
// this check, even when their venue has a lower package level.
export function isStaffScopedEditor(userInfo) {
  return (
    userInfo?.isStaffScopedEditor === true &&
    Number(userInfo?.user?.permissionLevel) === 9
  );
}

export function hasElevatedSessionAccess(userInfo, rolePermissionLevel, requiredLevel = 2) {
  return isStaffScopedEditor(userInfo) || Number(rolePermissionLevel) >= requiredLevel;
}
